import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL

const token = sessionStorage.getItem('token')
axios.defaults.headers.common.Authorization = `Bearer ${token}`

async function cancelLink(id, type) {
  try {
    const { status } = await axios.put(`${BASE_URL}${type}/${id}`)
    return status === 200
  } catch {
    return false
  }
}

async function cancelRecurrence(id) {
  try {
    const { status } = await axios.delete(`${BASE_URL}recurrence-link/${id}`)
    return status === 200
  } catch {
    return false
  }
}

async function getAll(page) {
  try {
    return await axios.get(`${BASE_URL}orders`, {
      params: {
        merchant_id: sessionStorage.getItem('veripagID'),
        page,
      },
    })
  } catch ({ response }) {
    return response
  }
}

async function getBankSlip(barCode) {
  try {
    return await axios.get(`${BASE_URL}bankslip/${barCode}`)
  } catch ({ response }) {
    return response
  }
}

async function getRecurrence(hash) {
  try {
    return await axios.get(`${BASE_URL}recurrence-link/${hash}`)
  } catch ({ response }) {
    return response
  }
}

async function getTransaction(hash) {
  try {
    const response = await axios.get(`${BASE_URL}payment-link/${hash}`)
    return response
  } catch ({ response }) {
    return response
  }
}

async function resendEmail(hash, type, mail = null) {
  try {
    const response = mail ? await axios.post(`${BASE_URL}${type}/mail/${hash}`, {
      email: mail,
    }) : await axios.post(`${BASE_URL}${type}/mail/${hash}`)
    return response
  } catch ({ response }) {
    return response
  }
}

export {
  cancelLink,
  cancelRecurrence,
  getAll,
  getBankSlip,
  getRecurrence,
  getTransaction,
  resendEmail,
}
